// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pairs-editor-container {
    padding-top: 20px;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

.editor-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.editor-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--brand-primary);
    margin: 0;
}

.court-count-badge {
    background-color: var(--bg-input);
    color: var(--text-muted);
    font-size: 0.85rem;
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 20px;
}

.courts-grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.court-card {
    background-color: var(--bg-card);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
}

.court-header {
    background-color: var(--bg-app);
    padding: 12px 20px;
    border-bottom: 1px solid var(--border-light);
    font-weight: 700;
    color: var(--brand-primary);
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 8px;
}

.court-header i {
    color: var(--brand-accent-fg);
    opacity: 0.7;
}

.pairs-container {
    padding: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
}

.pair-box {
    background-color: #fff;
    border: 1px dashed var(--border-light);
    border-radius: var(--radius-md);
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: relative;
    transition: border-color 0.2s;
}

.pair-box:hover {
    border-color: var(--brand-primary);
}

.pair-label {
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: var(--bg-card);
    padding: 0 8px;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--text-muted);
    text-transform: uppercase;
}

.select-group {
    position: relative;
}

.player-select {
    width: 100%;
    height: 44px;
    padding: 0 12px;
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    background-color: var(--bg-app);
    font-size: 0.9rem;
    color: var(--text-main);
    appearance: none;
    cursor: pointer;
    transition: all 0.2s;
}

.player-select:focus {
    outline: none;
    border-color: var(--brand-primary);
    background-color: #fff;
    box-shadow: var(--shadow-input-focus);
}

.select-group::after {
    content: '\\f107';
    font-family: 'FontAwesome';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--text-muted);
    pointer-events: none;
    font-size: 0.8rem;
}

.vs-divider {
    text-align: center;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--border-light);
    margin: -4px 0;
    text-transform: uppercase;
}

.editor-actions {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid var(--border-light);
}

.btn-save-pairs {
    background-color: var(--brand-primary);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: var(--radius-input);
    font-weight: 700;
    font-size: 1rem;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: var(--shadow-sm);
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-save-pairs:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-card);
}

.btn-save-pairs:disabled {
    background-color: #CBD5E1;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-md);
    margin-bottom: 20px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 8px;
}

@media (max-width: 600px) {
    .pairs-container {
        grid-template-columns: 1fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/AmericanaPairsEditor.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE5D;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,+BAA+B;IAC/B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,4CAA4C;IAC5C,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,sCAAsC;IACtC,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,gCAAgC;IAChC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qCAAqC;IACrC,kCAAkC;IAClC,+BAA+B;IAC/B,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,6BAA6B;IAC7B,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".pairs-editor-container {\n    padding-top: 20px;\n    animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\n\n.editor-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.editor-title {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--brand-primary);\n    margin: 0;\n}\n\n.court-count-badge {\n    background-color: var(--bg-input);\n    color: var(--text-muted);\n    font-size: 0.85rem;\n    font-weight: 600;\n    padding: 6px 12px;\n    border-radius: 20px;\n}\n\n.courts-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.court-card {\n    background-color: var(--bg-card);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-sm);\n    overflow: hidden;\n}\n\n.court-header {\n    background-color: var(--bg-app);\n    padding: 12px 20px;\n    border-bottom: 1px solid var(--border-light);\n    font-weight: 700;\n    color: var(--brand-primary);\n    font-size: 1rem;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.court-header i {\n    color: var(--brand-accent-fg);\n    opacity: 0.7;\n}\n\n.pairs-container {\n    padding: 20px;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 20px;\n}\n\n.pair-box {\n    background-color: #fff;\n    border: 1px dashed var(--border-light);\n    border-radius: var(--radius-md);\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    position: relative;\n    transition: border-color 0.2s;\n}\n\n.pair-box:hover {\n    border-color: var(--brand-primary);\n}\n\n.pair-label {\n    position: absolute;\n    top: -10px;\n    left: 10px;\n    background-color: var(--bg-card);\n    padding: 0 8px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: var(--text-muted);\n    text-transform: uppercase;\n}\n\n.select-group {\n    position: relative;\n}\n\n.player-select {\n    width: 100%;\n    height: 44px;\n    padding: 0 12px;\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    background-color: var(--bg-app);\n    font-size: 0.9rem;\n    color: var(--text-main);\n    appearance: none;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.player-select:focus {\n    outline: none;\n    border-color: var(--brand-primary);\n    background-color: #fff;\n    box-shadow: var(--shadow-input-focus);\n}\n\n.select-group::after {\n    content: '\\f107';\n    font-family: 'FontAwesome';\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--text-muted);\n    pointer-events: none;\n    font-size: 0.8rem;\n}\n\n.vs-divider {\n    text-align: center;\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: var(--border-light);\n    margin: -4px 0;\n    text-transform: uppercase;\n}\n\n.editor-actions {\n    margin-top: 30px;\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 20px;\n    border-top: 1px solid var(--border-light);\n}\n\n.btn-save-pairs {\n    background-color: var(--brand-primary);\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: var(--radius-input);\n    font-weight: 700;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: var(--shadow-sm);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.btn-save-pairs:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-card);\n}\n\n.btn-save-pairs:disabled {\n    background-color: #CBD5E1;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-md);\n    margin-bottom: 20px;\n    font-size: 0.9rem;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n@media (max-width: 600px) {\n    .pairs-container {\n        grid-template-columns: 1fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
